export const SET_WEB3 = 'SET_WEB3';
export const WALLET_CONNECT = 'WALLET_CONNECT';
export const BALANCES = 'BALANCES';
export const ISLOADHISTORY = 'ISLOADHISTORY';
